<div class="register_container">
	<div class="row">
		<div class="col-12">
			<div class="header">
				<img class="image-11" src="../assets/newimg/image-11-86@2x.png" alt="image 11" />
				<div class="flex-col">
					<div class="overlap-group-1">
						<p class="surname opensans-bold-sapphire-20px">
							<span class="opensans-normal-sapphire-20px">Cross</span>
							<span class="ellipsis"></span>
							<span class="opensans-extra-bold-sapphire-20px">Easy</span>
						</p>
					</div>
					<p class="brought-to-you-by-cr opensans-normal-star-dust-9px">
						<span class="opensans-normal-star-dust-9px">
							Brought to you by Cross-Border Road and Transport
							Agency
						</span>
					</p>
				</div>
			</div>
		</div>
	</div>
	<div class="row content_row">
		<div class="col-8 registration_form">
			<div class="heading">
				<h1>Registration</h1>
			</div>
			<p class="please-provide-us">
				Fields marked with <span class="required">*</span> are mandatory, Note that your email address will be
				your username.
			</p>
			<form [formGroup]="form" (ngSubmit)="onSubmit(form.value)" autocomplete="off">
				<div class="row form_row">
					<div class="col-6">
						<div class="form_field">
							<label class="label">First Name
								<span class="required">*</span>
							</label>
							<input type="text" name="FirstName" formControlName="FirstName" (blur)="getErrorFirtsName()"
								class="form-field input-sm" autocomplete="off" maxlength="50" [ngClass]="{
						  error:
							form.controls['FirstName'].touched &&
							form.controls['FirstName'].invalid
						}" />
							<div class="form-control-feedback error_message"
								*ngIf="form.controls.FirstName.touched && form.controls.FirstName.dirty">
								<p *ngIf="form.get('FirstName').hasError('required')">
									The first name is required
								</p>
								<p *ngIf="form.get('FirstName').hasError('minlength')">
									The first name is too short
								</p>
								<p *ngIf="form.get('FirstName').hasError('maxlength')">
									The first name is too long
								</p>
								<p *ngIf="form.get('FirstName').hasError('pattern')">
									The first name cannot have none alpha characters
								</p>
							</div>

						</div>
					</div>
					<div class="col-6">
						<div class="form_field">
							<label class="label">Last Name
								<span class="required">*</span>
							</label>
							<input type="text" name="LastName" formControlName="LastName" class="form-field input-sm"
								autocomplete="off" maxlength="50" [ngClass]="{
					  error:
						form.controls['LastName'].touched &&
						form.controls['LastName'].invalid
					}" />
							<div class="form-control-feedback error_message"
								*ngIf="form.controls.LastName.touched && form.controls.LastName.dirty">
								<p *ngIf="form.get('LastName').hasError('required')">
									The last name is required
								</p>
								<p *ngIf="form.get('LastName').hasError('minlength')">
									The last name is too short
								</p>
								<p *ngIf="form.get('LastName').hasError('maxlength')">
									The last name is too long
								</p>
								<p *ngIf="form.get('LastName').hasError('pattern')">
									The last name cannot have none alpha characters
								</p>
							</div>
						</div>
					</div>
					<div class="col-6">
						<div class="form_field">
							<label class="label">Mobile Number
								<span class="required">*</span>
							</label>
							<ngx-intl-tel-input [cssClass]="'form-field input-sm whiteNumber'"
								[preferredCountries]="preferredCountries" [enableAutoCountrySelect]="false"
								[enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="[
						  SearchCountryField.Iso2,
						  SearchCountryField.Name
						]" [selectFirstCountry]="false" [selectedCountryISO]="defaultCountry" [maxLength]="15"
								[tooltipField]="TooltipLabel.Name" [phoneValidation]="true"
								[separateDialCode]="separateDialCode" (countryChange)="ChangeCountry($event)"
								name="MobileNumber" formControlName="MobileNumber" #MobileNumber >
							</ngx-intl-tel-input>
							<div class="form-control-feedback error_message"
								*ngIf="form.controls.MobileNumber.touched && form.controls.MobileNumber.dirty">
								
								<p *ngIf="form.get('MobileNumber').hasError('required')">
									The mobile number is required
								</p>
							</div>
						</div>
					</div>
					<div class="col-6">
						<div class="form_field">
							<label class="label">Work Number
								<!-- <span class="required">*</span> -->
							</label>
							<ngx-intl-tel-input [cssClass]="'form-field input-sm whiteNumber'"
								[preferredCountries]="preferredCountries" [enableAutoCountrySelect]="false"
								[enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="[
					  SearchCountryField.Iso2,
					  SearchCountryField.Name
					]" [selectFirstCountry]="false" [selectedCountryISO]="defaultCountryPhone" [maxLength]="15"
								[tooltipField]="TooltipLabel.Name" [phoneValidation]="false"
								[separateDialCode]="separateDialCode" (countryChange)="ChangeCountryPhone($event)"
								name="PhoneNumber" formControlName="PhoneNumber">
							</ngx-intl-tel-input>
							<div class="form-control-feedback error_message"
								*ngIf="form.controls.PhoneNumber.touched && form.controls.PhoneNumber.dirty">
								<!--                <p *ngIf="form.get('PhoneNumber').hasError('required')">-->
								<!--                  The work number is required-->
								<!--                </p>-->
							</div>
						</div>
					</div>
					<div class="col-6">
						<div class="form_field">
							<label class="label">Email
								<span class="required">*</span>
							</label>
							<input type="text" name="email" formControlName="UserName" autocomplete="off"
								class="form-field input-sm" [ngClass]="{
						  error:
							form.controls['UserName'].touched &&
							form.controls['UserName'].invalid
						}" #email />
							<div class="form-control-feedback error_message"
								*ngIf="form.controls.UserName.invalid && form.controls.UserName.dirty">
								<div *ngIf="form.get('UserName').hasError('emailexists')">
									The email is already registered in the system, please try another
								</div>
								<p *ngIf="form.get('UserName').hasError('required')">
									The email is required
								</p>
								<p *ngIf="form.get('UserName').hasError('pattern')">
									The email format is invalid, verify if your email is correct
								</p>
							</div>
						</div>
					</div>

					<div class="col-6">
						<div class="form_field">
							<label class="label">Confirm Email
								<span class="required">*</span>
							</label>
							<input type="text" name="email" formControlName="EmailAddress" class="form-field input-sm"
								[ngClass]="{
					  error:
						form.controls['EmailAddress'].touched &&
						form.controls['EmailAddress'].invalid
					}" #cnfmEmail autocomplete="off" readonly onclick="this.removeAttribute('readonly');" />
							<div class="form-control-feedback error_message"
								*ngIf="form.controls.EmailAddress.touched && form.controls.EmailAddress.dirty && form.get('EmailAddress').invalid">
								<div *ngIf="form.get('EmailAddress').hasError('noMatch')">
									Emails do not match
								</div>
								<p *ngIf="form.get('EmailAddress').hasError('required')">
									The confirm email is required
								</p>
								<p *ngIf="form.get('EmailAddress').hasError('pattern')">
									The confirm email format is invalid, verify if your email is correct
								</p>
							</div>
						</div>
					</div>
					<div class="col-6">
						<div class="form_field">
							<label class="label">Password
								<span class="required">*</span>
							</label>

							<input [type]="hide ? 'password' : 'text'" name="Password" formControlName="Password"
								class="form-field input-sm blacktxt" minlength="8" [ngClass]="{
  error:
	form.controls['Password'].touched &&
	form.controls['Password'].invalid
}" autocomplete="off" #pwd />
							<span class="p-viewer">
								<i class="fa fa-eye-slash" *ngIf="hide == false" id="" (click)="showPassword()"
									aria-hidden="true"></i>
								<i class="fa fa-eye" *ngIf="form.value.Password && hide == true"
									(click)="showPassword()" id="" aria-hidden="true"></i>
							</span>
							<div class="form-control-feedback error_message"
								*ngIf="form.controls.Password.touched && form.controls.Password.dirty">
								<p *ngIf="form.get('Password').hasError('required')">
									The password is required
								</p>
								<p *ngIf="form.get('Password').hasError('pattern')">
									Passwords must be at least 8 characters long, must contain at least 1 uppercase
									letter, 1 lowercase letter, and 1 number
								</p>
							</div>
						</div>
					</div>
					<div class="col-6">
						<div class="form_field">
							<label class="label">Confirm Password
								<span class="required">*</span>
							</label>

							<input [type]="hide2 ? 'password' : 'text'" name="ConfirmPassword" minlength="8"
								formControlName="ConfirmPassword" class="form-field input-sm blacktxt" [ngClass]="{
	error:
	form.controls['ConfirmPassword'].touched &&
	form.controls['ConfirmPassword'].invalid
	}" #cnfPwd />
							<span class="p-viewer2">
								<i class="fa fa-eye-slash" *ngIf="hide2 == false" id="" (click)="showPassword2()"
									aria-hidden="true"></i>
								<i class="fa fa-eye" style="margin-left: -50%"
									*ngIf="form.value.ConfirmPassword && hide2 == true" (click)="showPassword2()" id=""
									aria-hidden="true"></i>

							</span>

							<div class="form-control-feedback error_message"
								*ngIf="form.controls.ConfirmPassword.touched && form.controls.ConfirmPassword.invalid && form.controls.ConfirmPassword.dirty">
								<p *ngIf="form.get('ConfirmPassword').hasError('required')">
									The confirm password is required
								</p>
								<div *ngIf="form.get('ConfirmPassword').hasError('noMatch')">
									The password and confirm password do not match
								</div>
							</div>
						</div>
					</div>

					<div class="col-6" style="display: none;">
						<div class="form_field">
							<label class="label">Role
								<span class="required">*</span>
							</label>
							<select formControlName="role" title="Select a role" [(ngModel)]="selectedRole"
								class="form-control form-control-sm" (change)="checked()">
								<ng-container>
									<option *ngFor="let r of Roles" [ngValue]="r" selected="r.ID == selectedRole.ID">
										{{ r.Description }}
									</option>
								</ng-container>
							</select>
						</div>
					</div>

					<div class="col-6">
						<div class="form_field confirmation_link">
							<legend class="label">Send confirmation link via:
								<span class="required">*</span>
							</legend>
							<div class="send-confirmation-link-via radio_btns_wrapper">
								<div class="radio_btn">
									<input type="radio" id="sms_radio" style="height: 20px; width: 20px"
										name="corspd-type" value="2" ([ngModel])="(correspondenceType)"
										[checked]="correspondenceType == '2'" (click)="selectcorrespondenceType('2')" />
									<label class="label" for="sms_radio">SMS </label>
								</div>
								<div class="radio_btn">
									<label class="label" for="sms_radio">OR</label>
								</div>
								<div class="radio_btn">
									<input type="radio" style="height: 20px; width: 20px" id="email_radio"
										name="corspd-type" value="1" ([ngModel])="(correspondenceType)"
										[checked]="correspondenceType == '1'" (click)="selectcorrespondenceType('1')" />
									<label class="label" for="email_radio">EMAIL</label>
								</div>
							</div>
						</div>
					</div>
					
					<div class="col-6">
						<div class="form_field">
							<div class="tnc">
								<input type="checkbox" class="checkbox" name="terms-check" value="1"
									([ngModel])="(terms)" [checked]="terms == '1'" (click)="ckeckTerms($event)" />
								<p class="by-clicking-the-chec">
									By clicking the checkbox, you note our
									<a href="#" data-toggle="modal" data-target="#POPIA">POPIA Processing
										Notices</a>
								</p>
							</div>
						</div>
						
					</div>
				
					<div class="col-6">
						<div class="form-group">
							<div class="form-group-input col-6" style="margin-left: -43px;">
								<p class="statedefaultNew">
									<re-captcha style=" width: 100% !important" (resolved)="resolved($event)"
										siteKey="{{ getSiteKey() }}">
									</re-captcha>
								</p>
							</div></div></div>
							<div class="register-btn-and-login-link col-6" style="margin-top: 5px !important">
								<div class="register-button-wrapper">
									<button type="submit" class="btn btn-warning #myRegBtn">Register</button>
								</div>
								<p class="already_have_an_account" ><a routerLink="/login">Already
									have an account? Click here to login.</a></p>
							</div>
						
				</div>
			</form>
		</div>

		<div class="col-4 parent">
			<div class="parents">
				<div class="overlap_group">
					<div class="surname">
						<span class="cross">Cross</span>
						<span class="ellipsis"></span>
						<span class="easy">Easy</span>
						<div class="here-there-everywhere">
							<span class="opensans-normal-white-16px">Here, There, Everywhere</span>
						</div>
					</div>
				</div>
				<div class="convenient-effectiv">
					<p>Convenient, Effective and</p>
					<p>Secure way to apply and</p>
					<p>manage your Permits</p>
					<p>Online</p>
				</div>
			</div>
		</div>
	</div>

	<div class="modal fade" id="POPIA" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
		aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLongTitle">
						POPIA Processing Notices
					</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body modal-lg">
					<div class="clearfix section pb-8 text-gray">
						<div class="">
							<div class="bg-transparent matrix-copy 1 1 normal">
								<div class="mb-0-lastchild">
									<h3 class="text-blue font-weight-semi-bold">
										Background to data privacy in South Africa
									</h3>
									<p>
										<br />The Protection of Personal Information Act, 4 of 2013,
										(“POPIA”), which came into force on 1 July 2021, is a law
										which regulates the use and processing of a person and /
										legal entity’s personal information, this being in response
										to, and in order to protect and give effect to a person
										and/or legal entity’s rights to privacy, including the right
										not to have their / its personal information and related
										data misused, abused or used for ulterior purposes.
									</p>
									<p>
										POPIA applies to personal information which belongs to
										individuals and legal entities (“Data Subjects”) which is
										processed, be it in an automated or non-automated manner in
										South Africa, by another (“Responsible Party”) and places on
										any Responsible Party who is processing a data Subject’s
										personal information, a duty to use it lawfully and only for
										a specific and defined purpose(s).
									</p>
									<p>
										In terms of POPIA, Cross Border Road Transport Agency
										(C-BRTA) , as a Responsible Party, is required to appoint an
										Information Officer (“IO”) and Deputy Information Officers
										(“DIOs”), to be responsible for establishing a POPIA
										Compliance Framework, and who following this, are required
										to assess, analyse and understand what types of personal
										information C-BRTA is processing which belongs to Data
										Subjects and to thereafter develop certain processes and
										procedures, including a POPIA Policy, which have to be
										followed by all C-BRTA employees when they process and use
										another’s personal information.
									</p>
									<p>
										A Personal Information Impact Assessment as per the C-BRTA’s
										POPIA Compliance Framework has been carried out and created,
										which has indicated that C-BRTA , during the course of its
										business activities does and will continue to collect, store
										and process personal information about C-BRTA employees, its
										customers, suppliers and other third parties.
									</p>
									<p>
										Furthermore, the Impact Assessment has defined and revealed
										that C-BRTA processes a large amount of different types of
										personal information including names, addresses, opinions,
										financial details, medical details and the like which
										pertain to current, past and prospective employees and
										customers, suppliers, and others who C-BRTA communicates and
										deals with and which processing is carried out for a variety
										of purposes, including for business, compliance and legal
										purposes.
									</p>
									<p>
										C-BRTA also processes special purpose information including
										gender, sex, marital status, colour, age, race or ethnic
										origin, religious beliefs, trade union membership and the
										like for the purposes of recruitment, employment equity
										statistics, legal compliance and for the facilitation of
										union fees and memberships.
									</p>
									<p>
										Following the Personal Information Impact Assessment, C-BRTA
										is confident that whilst this personal information is held
										on paper or on a computer or other media, such storage is
										subject to the prescribed legal safeguards as specified in
										POPIA and other regulations.
									</p>
									<p>
										As per the POPIA requirements has implemented a robust POPIA
										compliance programme which includes various POPIA policies
										and processes, some of which are internal documents and some
										are which are available for public access. These documents
										are available for public access and can be accessed in the
										menu on the left.<br />
									</p>
									<p><br /></p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-md pull-right mr-2 mt-2 btn-warning" data-dismiss="modal">
						Close
					</button>
				</div>
			</div>
		</div>
	</div>
</div>